<template>
  <div
    :class="
      cn(
        'flex items-center bg-secondary border border-secondary rounded-full',
        variants({ size })
      )
    "
  >
    <div
      :class="
        cn(
          'flex items-center grow ltr:pr-2 ltr:pl-4 rtl:pl-2 rtl:pr-4 gap-3 overflow-hidden',
          variants({ size })
        )
      "
    >
      <AvatarBuilding
        :item="item"
        :size="maxSmall ? 'sm' : '2xs'"
        class="dark"
        active
      />
      <span
        :title="item.name"
        class="text-style-base sm:text-style-sm font-semibold truncate fg-secondary"
      >
        {{ item.name }}
      </span>
    </div>
    <ToggleGroupRoot :class="cn('ltr:-mr-px rtl:-ml-px', variants({ size }))">
      <div class="flex items-center gap-2">
        <slot />
      </div>
    </ToggleGroupRoot>
  </div>
</template>
<script setup>
import { variants } from "@/SharedComponents/BuildingToggleList";
import { AvatarBuilding } from "@/SharedComponents/Avatars";
import { ToggleGroupRoot } from "@/SharedComponents/Toggles";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { cn } from "@/Utils/cn";

const { maxSmall } = useBreakpoints();

defineProps({
  item: { type: Object, required: true },
  size: { type: String, required: false },
});
</script>
